import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'
import { Inject, Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { EventTicketPackageEntity } from 'libs/gb-front/event-tickets/data-access-event-ticket-packages/src/lib/+state/event-ticket-packages.models'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { GbNotificationService } from 'libs/shared/utils/notification/src/lib/service/gb-notification.service'
import { Observable, filter, of, take, tap } from 'rxjs'
import { GbAuctionMetaService } from 'libs/gb-front/auction/util/src/lib/gb-auction-meta/gb-auction-meta.service'
import { UseTagsEnum } from 'libs/gb-front/auction/util/src/lib/gb-auction-meta/gb-auction-meta.models'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src/lib/+state/auction.facade'
import { TaxesEntity } from 'libs/gb-front/auction/data-access/src/lib/+state/taxes.models'

@Injectable({
  providedIn: 'root',
})
export class GbBaseDetail {
  facebookLink = ''
  twitterLink = ''

  smBreakpoint$ = this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall])

  lgBreakpoint$ = this.breakpointObserver.observe([Breakpoints.Large, Breakpoints.XLarge])

  scrollOnRouterEvents$ = this.router.events.pipe(
    filter((events) => events instanceof NavigationEnd),
    // scroll to top on router events
    tap(() => this.scrollToTop()),
  )

  /**
   * Returns current URL with query string removed
   */
  get currentUrl(): string {
    return `https://${this.appConfig.appUrl}${this.router.url.split('?')[0]}`
  }

  constructor(
    @Inject(APP_CONFIG) protected appConfig: any,
    protected auctionFacade: AuctionFacade,
    protected gbNotificationService: GbNotificationService,
    protected gbAuctionMetaService: GbAuctionMetaService,
    protected breakpointObserver: BreakpointObserver,
    protected router: Router,
  ) {}

  setShareLinks(item$: Observable<ItemEntity | EventTicketPackageEntity | undefined>): void {
    item$.pipe(take(1)).subscribe((item) => {
      if (item) {
        this.facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
        this.twitterLink = `https://twitter.com/intent/tweet?original_referer=${this.currentUrl}&text=${item.name}&tw_p=tweetbutton&url=${this.currentUrl}&via=galabid`
      }
    })
  }

  setUseTag(useTag: UseTagsEnum): void {
    this.gbAuctionMetaService.useTagSubject$.next(useTag)
  }

  getTax(uuid: string | null): Observable<TaxesEntity | undefined> {
    return uuid ? this.auctionFacade.getTaxByUuid$(uuid) : of(undefined)
  }

  onCopyLink(): void {
    this.gbNotificationService.message('SOCIAL_MEDIA.LINK_COPIED')
  }

  scrollToTop(): void {
    ;['.item-action-card', '.mat-sidenav-content'].forEach((item) => document.querySelector(item)?.scrollTo(0, 0))
  }
}
